export default {
    WEB_NAME: "山东消费网",
    WEB_SITE: "https://315sd.com",
};